import { combineLatestWith, map, startWith } from 'rxjs/operators';
import { of } from 'rxjs';
import lodashGet from 'lodash/get';
import { api as masterApi } from '@/api/api';
import { apis } from '@/config';
export class IMNotify {
    constructor() {
        this.$nimInstance = null;
        this.pushApi = masterApi.requireLogicalApi(apis.pushApiImpl);
        this.p2pMuteSubject = of([]);
        this.teamMuteSubject = of([]);
    }
    init($instance) {
        const { sessionStream, p2pMuteStream, teamMuteStream } = $instance;
        const sessionSubject = sessionStream.getSubject();
        const p2pMuteSubject = p2pMuteStream.getSubject();
        this.p2pMuteSubject = p2pMuteSubject;
        const teamMuteSubject = teamMuteStream.getSubject();
        this.teamMuteSubject = teamMuteSubject;
        sessionSubject
            .pipe(map(list => list.filter(item => lodashGet(item, 'unread', 0) !== 0)), combineLatestWith(p2pMuteSubject, teamMuteSubject), map(args => {
            const [sessionList, p2pMuteList, teamMuteList] = args;
            return sessionList.filter(item => {
                if (item.scene === 'p2p') {
                    return !p2pMuteList.includes(item.to);
                }
                return !teamMuteList.includes(item.to);
            });
        }), map(list => list.reduce((total, current) => total + current.unread, 0)))
            .subscribe(count => {
            this.pushApi.triggerNotificationInfoChange({
                action: 'new_im_msg_num',
                num: count,
                content: '',
                title: '',
            });
        });
    }
    subscribeMuteStatus($sessionId, _ = false) {
        return $sessionId.pipe(combineLatestWith(this.p2pMuteSubject, this.teamMuteSubject), map(([sessionId, p2pMuteList, teamMuteList]) => {
            const id = sessionId.replace(/^(p2p|team)-/, '');
            if (/^p2p/.test(sessionId)) {
                return p2pMuteList.includes(id);
            }
            return teamMuteList.includes(id);
        }), startWith(_));
    }
}
export const imnotifyInstance = new IMNotify();
